import { MenuEntry } from '@pancakeswap-libs/uikit'

const config: MenuEntry[] = [
  {
    label: 'Home',
    icon: 'HomeIcon',
    href:  'https://bsc.ibg.finance', 
  },
  {
    label: 'Trade',
    icon: 'TradeIcon',
    items: [
      {
        label: 'Exchange',
        href: 'https://amm.ibg.finance/#/swap?outputCurrency=0x5c46c55a699a6359e451b2c99344138420c87261', // 'https://exchange.goosedefi.com/',
      },
      {
        label: 'Liquidity',
        href:  'https://amm.ibg.finance/#/pool', // 'https://exchange.goosedefi.com/#/pool',
      },
    ],
  },
  // {
  //   label: 'Farming',
  //   icon: 'FarmIcon',
  //   href: '/farms',
  // },



  {
    label: 'IBG Super Staking',
    icon: 'VaultsIcon',
    href:  '/superibg', 
  },

  {
    label: 'Farming',
    icon: 'FarmIcon',
    items: [
      {
        label: 'IBG Booster (OLD)',
        href:  'https://booster.ibg.finance/ibgbooster', 
      },
      
      {
        label: 'Withdraw (Old)',
        href:  'https://farm1.ibg.finance/withdraw', 
      },
      {
        label: 'V2',
        href:  'https://bsc.ibg.finance/farms', 
     
      },
    ],
  },

  {
    label: 'Staking',
    icon: 'PoolIcon',
    items: [
      {
        label: 'Withdraw (Old)',
        href:  'https://farm1.ibg.finance/withdraw', 
      },
      {
        label: 'V2',
        href:  'https://bsc.ibg.finance/pools', 
     
      },
    ],
  },



  {
    label: 'Old Farms & Pools',
    icon: 'FarmIcon',
    href: 'https://oldbsc.ibg.finance',
  },



  // {
  //   label: 'Withdraw (Old)',
  //   icon: 'FarmIcon',
  //   href:  'https://farm1.ibg.finance/withdraw', 
  // },
  // {
  //   label: 'Staking',
  //   icon: 'PoolIcon',
  //   href:  '/pools',
  // },



  {
    label: 'Price Charts',
    icon: 'InfoIcon',
    initialOpenState: false,
    items: [
      {
        label: 'Dex Guru',
        href: 'https://dex.guru/token/0x5c46c55a699a6359e451b2c99344138420c87261-bsc',
      },
      {
        label: 'Poo Coin',
        href: 'https://poocoin.app/tokens/0x5c46c55a699a6359e451b2c99344138420c87261',
      },
      {
        label: 'Bogged Finance',
        href: 'https://charts.bogged.finance/?token=0x5c46c55a699a6359e451b2c99344138420c87261',
      },
      {
        label: 'Dex Tools',
        href: 'https://www.dextools.io/app/pancakeswap/pair-explorer/0x8673491B4B72695D4BE789fe814D1dd0988e19A8',
      },
    ],
  },
  // {
  //   label: 'Pools',
  //   icon: 'PoolIcon',
  //   href: '/pools',
  // },
  // {
  //   label: 'Lottery',
  //   icon: 'TicketIcon',
  //   href: '/lottery',
  // },
  // {
  //   label: 'NFT',
  //   icon: 'NftIcon',
  //   href: '/nft',
  // },
  // {
  //   label: 'Info',
  //   icon: 'InfoIcon',
  //   items: [
  //     {
  //       label: 'Swap',
  //       href: '/', //  'https://pancakeswap.info/token/0xF952Fc3ca7325Cc27D15885d37117676d25BfdA6',
  //     },
  //     {
  //       label: 'CoinGecko',
  //       href: '/', // 'https://www.coingecko.com/en/coins/goose-finance',
  //     },
  //     {
  //       label: 'CoinMarketCap',
  //       href: '/', // 'https://coinmarketcap.com/currencies/goose-finance/',
  //     },
  //     {
  //       label: 'AstroTools',
  //       href: '/', // 'https://app.astrotools.io/pancake-pair-explorer/0x19e7cbecdd23a16dfa5573df54d98f7caae03019',
  //     },
  //   ],
  // },
  {
    label: 'Audits',
    icon: 'AuditIcon',
    href:"https://github.com/IBG-Finance-Defi/IBG-Farms-build/blob/main/audits/bsc.pdf"
  }
  // {
  //   label: 'Partnerships/IFO',
  //   icon: 'GooseIcon',
  //   href:'/', //  'https://docs.google.com/forms/d/e/1FAIpQLSe7ycrw8Dq4C5Vjc9WNlRtTxEhFDB1Ny6jlAByZ2Y6qBo7SKg/viewform?usp=sf_link',
  // },
  // {
  //   label: 'Audit by Hacken',
  //   icon: 'AuditIcon',
  //   href: '/', // 'https://www.goosedefi.com/files/hackenAudit.pdf',
  // },
  // {
  //   label: 'Audit by CertiK',
  //   icon: 'AuditIcon',
  //   href:'/', //  'https://certik.org/projects/goose-finance',
  // },
]

export default config
